<script setup>
/**
 * Verkoop-footer. Bootstrap (contact, links) komt uit vsb_footer_bootstrap.php.
 * Zelfde opbouw als Verhuur; alleen de accentkleur is Verkoop-blauw.
 */
import VerhuurFooter from '@verhuur/footer/SiteFooter.vue';
</script>

<template>
  <div class="vsb-verkoop-footer">
    <VerhuurFooter />
  </div>
</template>

<style scoped>
/* Verkoop-merkblauw (#004494) i.p.v. Verhuur-navy (#0b3d91) */
.vsb-verkoop-footer {
  --vsb-blue-dark: #004494;
  --vsb-blue-mid: #1560c4;
}
</style>
